<template>
    <div>
        <div class="searchItem flex " v-if="isShow==true">
            <div class="item">
                <el-date-picker style="width: 100%" clearable
                                v-model="begin_time"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>

                <span style="width: 110px;text-align: center;">至</span>
                <el-date-picker style="width: 100%" clearable
                                v-model="end_time"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>
                <el-select class="mr10" v-model="state" placeholder="请选择" clearable>
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="searchDingYue" style="margin-left: 30px">检索</el-button>
        </div>
        <el-table tooltip-effect="dark" align="center"  ref="singleTable" height="550" :data="GetChooseData" @current-change="handleCurrentChangeZsj" highlight-current-row>
            <el-table-column width="" property="i_id" label="ID" align="center"></el-table-column>
            <el-table-column width="" property="vc_name" label="名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column width="" property="vc_app" label="订阅系统" align="center"></el-table-column>
            <el-table-column width="" property="i_sysid" label="主数据id" align="center"></el-table-column>
            <el-table-column width="" property="i_id" label="订阅id" align="center"></el-table-column>
            <el-table-column width="" property="dt_createtime" label="保存时间" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column width="" property="vc_user" label="账套" align="center"></el-table-column>
            <el-table-column width="" property="i_state" label="状态" align="center" :formatter="State"></el-table-column>
            <el-table-column
                    align="center"
                    label="操作"
                    width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="small" style="color: red" @click="republish(scope.row)" v-if="scope.row.i_state=='003'">重新发布</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableBottom flex fle-item flex-just mt20">
            <!--                    <div class="tbLeft">-->
            <!--                        <el-button type="primary">批量发布</el-button>-->
            <!--                        <el-button type="primary">批量冻结</el-button>-->
            <!--                    </div>-->
            <div class="tbRight">
                <div class="paginationBox textRig" >
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            @current-change="pageCurrentChange"
                            :current-page.sync="currentPage"
                            :total="tableTotal">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    export default {
        name: "SubScribe",
        props:{
            subscribe:{
                type:Object,
                required:true,
            },
        },
        data(){
            return{
                state:"",
                options: [
                    {
                        value: '001',
                        label: '发送中'
                    },{
                    value: '002',
                    label: '已发送'
                }, {
                    value: '003',
                    label: '异常'
                }],
                isShow:false,
                begin_time:"",
                end_time:"",
                GetChooseData:[],
                state:"",
                tableTotal:0,
                currentPage:1,
                pageSize:1,
            }
        },
        watch:{
            subscribe:{
                handler:function (val) {
                    this.val=val || {};
                    //console.log("11111",val)
                    this.i_id=val.i_id;
                    this.isShow=val.isShow;
                },
                deep:true,
            }
        },
        mounted(){
            //console.log("11111",this.subscribe)
            this.isShow=this.subscribe.isShow;
            this.i_id=this.subscribe.i_id;
            this.relationData();
        },
        methods:{

            async relationData(value){
                this.currentRow="";
                let param={
                    i_id:this.i_id,
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    vc_state:this.state,
                    data_type: "product",
                    page_size:this.pageSize,
                    page_count:10,
                    begin_time:this.begin_time,
                    end_time:this.end_time,
                };
                let res=await API.getMDataDetails(param);
                if(res.code==1){
                    //this.chooseDataList=true;
                    //console.log("res",res);
                    this.GetChooseData= res.data;
                    //console.log("GetChooseData",typeof this.GetChooseData);
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //搜索订阅
            searchDingYue(){
                this.relationData();
            },
            //重新发布
            async republish(){
                let param={
                    i_id:0,
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    fileid:"",
                    data_type: "product",
                    //tableData: [],
                };
                /*let res=await API.republish(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.dialogFormVisibleData=false;
                    this.getMDSysMessage();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };*/
            },
            State(row, column, cellValue, index){
                if(row.i_state==='001'){
                    return '发送中'
                }else if(row.i_state==='002'){
                    return '已发送'
                }else if(row.i_state==='003'){
                    return '异常'
                }
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
                this.relationData();
            },
            handleCurrentChangeZsj:function(val) {
                this.currentRow  = val;
                //console.log(val)
                if(this.currentRow!=null && this.currentRow!=""){
                    //this.glData=this.currentRow;
                    this.zi_id=this.currentRow.i_id;
                    this.chooseDataList=false;
                    this.chooseData=false;
                    this.isRelation=false;
                }
            },
        }
    }
</script>

<style lang="scss"  scoped>
    .searchItem{
        .item{
            width: 40%;

        }
        .mr10{
            margin-left: 20px;
            width: 100%;
        }
    }
</style>